import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/services/global.service';
import { GroupService } from 'src/app/services/group.service';
import { CustomerService } from 'src/app/services/customer.service';
import { OperatorService } from 'src/app/services/operator.service';

import { faUserCircle, faBuilding } from '@fortawesome/free-regular-svg-icons';
import { faSearch, faLayerGroup, faUsers, faPlus, faUser } from '@fortawesome/free-solid-svg-icons';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { EliminaComponent } from 'src/app/popup/elimina/elimina.component';

@Component({
  selector: 'app-group',
  templateUrl: './group.component.html',
  styleUrls: ['./group.component.css']
})

export class GroupComponent implements OnInit {

  //string
  token: string;
  _listFilter: string = '';
  tempID: string;
  tempAlfrescoID: string;

  //boolean
  choose: boolean = false;
  newGrou = false;
  del = false;
  deleteUser = false;
  new = false;
  groupNew = false;
  action = false;
  addList = false;
  nome: boolean;

  //temp
  tempUser: any;

  //Icone
  faUserCircle = faUserCircle;
  faBuilding = faBuilding;
  faSearch = faSearch;
  faLayerGroup = faLayerGroup;
  faUsers = faUsers;
  faUser = faUser;
  faPlus = faPlus;

  deleteGroups: any = [];
  deleteOperators: any = [];
  deleteCustomer: any = [];

  addGroups: any = [];
  addOperators: any = [];
  addCustomer: any = [];

  groups: any;
  filteredGroups: Array<any>;
  activeUser: any;
  selectedGroup: any;
  customers: any;
  operators: any;
  groupAdd: any = [];
  groupAddC: any = [];
  groupAddO: any = [];
  groupAddGrp: any = [];
  groupCustomers: Array<any> = [
    {
      name: "name",
      last_name: "last_name",
      business_name: "business_name"
    }
  ]
  groupOperators: Array<any> = [
    {
      name: "name",
      last_name: "last_name",
      username: "username"
    }
  ]
  groupGroups: Array<any> = [
    {
      group_name: "group_name"
    }
  ]
  constructor(private groupService: GroupService,
    private globals: GlobalService,
    private customerService: CustomerService,
    private operatorService: OperatorService,
    private modalService: NgbModal
  ) {
    this.filteredGroups = this.groups;
  }

  ngOnInit() {
    this.globals.checkPage(7);
    if (!this.token) {
      this.token = this.globals.getToken();
    }
    this.getGroups();
    this.getOperators();
    this.getCustomers();
    this.activeUser = this.globals.storagedUser;
  }

  reload() {
    this.groupNew = false;
    this.deleteGroups = []
    this.deleteOperators = []
    this.deleteCustomer = []
    this.newGrou = false;
    this.action = false;
    this.new = false;
    this.deleteUser = false;
    this.groupAdd = [];
    this.groupAddC = [];
    this.groupAddO = [];
    this.groupAddGrp = null;
    this.selectedGroup = {};
    this.del = false;
    // this.groupNew = true;
    this.tempUser = null;
    this.choose = false;
    this.getGroups();
    this.getOperators();
    this.getCustomers();
  }

  get listFilter(): string {
    return this._listFilter;
  }

  set listFilter(value: string) {
    this._listFilter = value;
    this.filteredGroups = this.listFilter ? this.doFilter(this.listFilter) : this.groups;
  }

  doFilter(filterBy: string) {
    filterBy = filterBy.toLocaleLowerCase();
    return this.groups.filter((group) =>
      group.searchField.toLocaleLowerCase().indexOf(filterBy) !== -1);
  }

  getGroups() {
    this.groupService.getGroups(this.token).subscribe(
      res => {
        this.new = false;
        this.deleteUser = false;
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.groups = res;
          this.groups.forEach((group) => {
            if (group.group_name == 'clienti' || group.group_name == 'operatori') {
              group.visible = false;
            } else {
              group.visible = true;
            }
          })
          // Creo il campo descrizione per il campo di ricerca
          this.groups.forEach(group => {
            group.searchField = `${group.group_name} ${group.group_name}`;
          })
          this.listFilter = '';
        }
      },
      err => {
        console.error("Errore in getOperators", err);
      }
    )
  }

  newGroup() {
    this.svuotaSpan();
    this.groupNew = false;
    this.deleteUser = false;
    this.action = false;
    this.new = false;
    this.deleteUser = false;
    this.groupAdd = [];
    this.groupAddC = [];
    this.groupAddO = [];
    this.del = true;
    this.choose = true;
    this.newGrou = true;
    this.groupAddGrp = null;
    this.selectedGroup = {};
    this.groupAddC = [];
    this.groupAddO = [];
    this.groupAddGrp = [];
    new Promise((resolve, reject) => {
      this.getCustomers();
      this.getOperators();
      resolve();
    }).then(() => {
      if (this.tempUser) {
        var elementTwo = document.getElementById(this.tempUser);
        elementTwo.classList.remove("color-change")
      }
    }).catch((err) => {
      console.error("Error on get  Customers or Operators", err);

    })


  }

  getCustomers() {
    this.customerService.getCustomer(this.token).subscribe(
      res => {
        this.new = false;
        this.deleteUser = false;
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.customers = res;
        }
      },
      err => {
        console.error("Errore: ", err);
      }
    )
  }

  getOperators() {
    this.operatorService.getOperator(this.token).subscribe(
      res => {
        this.new = false;
        this.deleteUser = false;
        if (res.error) {
          return this.globals.errorSniffer(res.error);
        } else {
          this.operators = res;
        }
      },
      err => {
        console.error("Errore: ", err);
      }
    )
  }

  push(add) {
    let control: boolean = false

    if (add) {
      if (add.customer_id) {
        this.groupAddC.forEach(cus => {
          if (cus.customer_id == add.customer_id) {
            control = true;
          }
        });

      }

      if (add.user_id) {
        this.groupAddO.forEach(op => {
          if (op.user_id == add.user_id) {
            control = true;
          }
        });

      }

      if (add.group_id) {
        this.groupAddGrp.forEach(grp => {
          if (grp.group_id == add.group_id) {
            control = true;
          }
        });

      }
      if (this.selectedGroup.customers) {
        this.selectedGroup.customers.forEach(cus => {
          if (cus.customer_id == add.customer_id) {
            control = true;
          }
        });
      }

      if (this.selectedGroup.groups) {
        this.selectedGroup.groups.forEach(grp => {
          if (grp.group_id == add.group_id) {
            control = true;
          }
        });
      }

      if (this.selectedGroup.operators) {
        this.selectedGroup.operators.forEach(op => {
          if (op.user_id == add.user_id) {
            control = true;
          }
        });
      }

      if (control == false) {
        let obj: any;
        this.groupAdd.push(add);
        if (add.customer_id) {
          this.groupAddC.push(add);
          if (!this.newGrou) {
            this.selectedGroup.customers.push(add);
          }
          obj = {
            customer_id: add.customer_id,
            alfresco_id: add.alfresco_id
          }
          this.addCustomer.push(obj);
        }
        if (add.user_id) {
          this.groupAddO.push(add);
          if (!this.newGrou) {
            this.selectedGroup.operators.push(add);
          }
          obj = {
            user_id: add.user_id,
            alfresco_id: add.alfresco_id
          }
          this.addOperators.push(obj);
        }
        if (add.group_id) {
          this.groupAddGrp.push(add);
          if (!this.newGrou) {
            this.selectedGroup.groups.push(add);
          }
          obj = {
            group_id: add.group_id,
            alfresco_id: add.alfresco_id
          }
          this.addGroups.push(obj);
        }


      } else {
        alert("il profilo selezionato è già stato inserito nella lista")
      }
    } else {
      alert("Seleziona un profilo")
    }
  }

  addMemberGroup() {
    let obj = {
      alfresco_id: this.tempAlfrescoID,
      customers: this.addCustomer,
      operators: this.addOperators,
      groups: this.addGroups
    }

    console.log(obj);

    this.groupService.addMember(this.token, this.tempID, obj).subscribe(
      res => {
        this.reload();
      },
      err => {
        console.error("Errore in addMemberGroup: ", err);
      }

    )
  }

  deleteNew(cus) {
    if (cus.customer_id) {
      this.groupAddC.splice(this.groupAddC.indexOf(cus), 1)
    }

    if (cus.user_id) {
      this.groupAddO.splice(this.groupAddO.indexOf(cus), 1)
    }

    if (cus.group_id) {
      this.groupAddGrp.splice(this.groupAddGrp.indexOf(cus), 1)
    }
  }

  deleteFull() {
    let obj = {
      alfresco_id: this.tempAlfrescoID,
      customers: this.deleteCustomer,
      operators: this.deleteOperators,
      groups: this.deleteGroups
    }

    console.log(obj);

    this.groupService.delMember(this.token, this.tempID, obj).subscribe(
      res => {
        this.reload();
      },
      err => {
        console.error("Errore in deleteFull: ", err);
      }

    )
  }

  refresh(name, desc) {

    if (name) {
      this.nome = true;
      document.getElementById("nuovo").innerHTML = "";
    } else {
      this.nome = false;
      document.getElementById("nuovo").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (this.nome) {

      let obj = {
        group_name: name,
        description: desc
      }
      this.groupService.updateNameGroup(this.token, this.tempID, obj).subscribe(
        res => {
          this.reload();
        },
        err => {
          console.error("errore in updateNameGroup: ", err);

        }
      )
    }
  }

  delete(list) {
    if (list.customer_id) {
      let obj = {
        customer_id: list.customer_id,
        alfresco_id: list.alfresco_id
      }
      this.deleteCustomer.push(obj);
      this.selectedGroup.customers.splice(this.selectedGroup.customers.indexOf(list), 1);
    }

    if (list.user_id) {
      let obj = {
        user_id: list.user_id,
        alfresco_id: list.alfresco_id
      }
      this.deleteOperators.push(obj);
      this.selectedGroup.operators.splice(this.selectedGroup.operators.indexOf(list), 1);
    }

    if (list.group_name) {
      let obj = {
        group_id: list.group_id,
        alfresco_id: list.alfresco_id
      }
      this.deleteGroups.push(obj);
      this.selectedGroup.groups.splice(this.selectedGroup.groups.indexOf(list), 1);
    }
  }

  svuotaSpan() {
    if (document.getElementById("nuovo")) {
      document.getElementById("nuovo").innerHTML = "";
    }
  }

  createGroup(group) {

    if (group.group_name) {
      this.nome = true;
      document.getElementById("nuovo").innerHTML = "";
    } else {
      this.nome = false;
      document.getElementById("nuovo").innerHTML = "↓ Il campo è obbligatorio";
    }

    if (this.nome) {

      if (this.nome) {
        let groupToSend = {
          info: group,
          customers: this.groupAddC ? this.groupAddC : [],
          operators: this.groupAddO ? this.groupAddO : [],
          groups: this.groupAddGrp ? this.groupAddGrp : []
        }

        this.groupService.newGroup(this.token, groupToSend).subscribe(
          res => {
            this.reload();
          },
          err => {
            console.error("Errore nel creare il nuovo gruppo", err);
          }
        )
      }
    }
  }

  showForm(group) {
    this.svuotaSpan();
    this.groupAddGrp = null;
    this.selectedGroup = {};
    this.groupAddC = [];
    this.groupAddO = [];
    this.groupAddGrp = [];
    this.groupService.getGroup(this.token, group.group_id).subscribe(
      res => {
        this.newGrou = false;
        this.action = true;
        this.deleteUser = false;
        this.new = false;
        this.deleteUser = false;
        this.selectedGroup = res;
        this.groupNew = true;
        this.del = true;
        this.choose = true;
        if (this.tempUser) {
          // Toglie il colore (bianco)
          var elementTwo = document.getElementById(this.tempUser);
          elementTwo.classList.remove("color-change")
        }
        // Mette il colore (bianco)
        var element = document.getElementById(`group${group.group_id}`);
        element.classList.add("color-change");
        this.tempUser = `group${group.group_id}`;
        this.tempID = group.group_id;
        this.tempAlfrescoID = group.alfresco_id
        // this.selectedGroup = group;
      }
    )
  }

  deleteGroup(group) {
    const modalRef = this.modalService.open(EliminaComponent, { backdrop: 'static', centered: true })
    modalRef.componentInstance.token = this.token;
    modalRef.componentInstance.group = group;

    modalRef.result.then(result => {
      if (result != 'cancel') {
        this.tempUser = null;
        this.reload();
        let element = document.getElementById(`group${result}`);
        element.classList.remove("color-change")
      }
    });
  }

  aggiugi() {

  }

  deleteUs() {
    this.deleteUser = true;
    this.new = false;
    this.groupNew = false;
    this.action = false;
    this.newGrou = false;
    this.deleteGroups = []
    this.deleteOperators = []
    this.deleteCustomer = []
    this.addCustomer = [];
    this.addOperators = [];
    this.addGroups = [];
  }

  add() {
    this.new = true;
    this.deleteUser = false;
    this.groupNew = true;
    this.action = false;
    this.newGrou = false;
    this.deleteGroups = []
    this.deleteOperators = []
    this.deleteCustomer = []
    this.addCustomer = [];
    this.addOperators = [];
    this.addGroups = [];
  }
}